/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import MuiDialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

// Templates
import CreateBookingDialog from './booking/CreateBookingDialog';
import AddBlockDialog from './documents/AddBlockDialog';
import MeetingSettingsDialog from './meetings/SettingsDialog';
import MeetingInfoDialog from './meetings/MeetingInfoDialog';
import AssetDialog from './folders/assets/AssetDialog';
import DeleteFolderDialog from './folders/DeleteFolderDialog';
import EditFolderNameDialog from './folders/EditFolderNameDialog';
import CreateDocumentDialog from './documents/CreateDocumentDialog';
import UpdateDocumentDialog from './documents/UpdateDocumentDialog';
import ChangeDocumentTemplateDialog from './documents/ChangeDocumentTemplateDialog';
import PromptDialog from './common/PromptDialog';
import FlowTemplateDialog from './flow/templates/FlowTemplateDialog';
import TransformImageDialog from './folders/assets/TransformImageDialog';

import { useStore, DIALOG } from '../store';

export default function Dialog() {
  const [dialog, setDialog] = useStore(DIALOG);

  function onClose(val) {
    if (typeof dialog.onClose === 'function') {
      dialog.onClose(val);
    }

    setDialog({
      ...dialog,
      type: null,
      open: false,
    });
  }

  if (!dialog) return null;
  if (dialog.type) {
    switch (dialog.type) {
      case 'createBooking':
        return (
          <CreateBookingDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      case 'addBlock':
        return (
          <AddBlockDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      case 'meetingSettings':
        return (
          <MeetingSettingsDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      case 'meetingInfo':
        return (
          <MeetingInfoDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      case 'assetPicker':
        return (
          <AssetDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
            singleSelect={dialog?.data?.singleSelect}
            folderSelect={dialog?.data?.folderSelect}
            hideFilters={dialog?.data?.hideFilters}
          />
        );
      case 'deleteFolder':
        return (
          <DeleteFolderDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      case 'editFolderName':
        return (
          <EditFolderNameDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      case 'createDocument':
        return (
          <CreateDocumentDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      case 'updateDocument':
        return (
          <UpdateDocumentDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      case 'changeDocumentTemplate':
        return (
          <ChangeDocumentTemplateDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );

      case 'flowTemplate':
        return (
          <FlowTemplateDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      case 'prompt':
        return <PromptDialog {...dialog} onClose={onClose} />;
      case 'transformImage':
        return (
          <TransformImageDialog
            open={dialog?.open}
            onClose={onClose}
            data={dialog?.data}
          />
        );
      default:
        return null;
    }
  }

  return (
    <MuiDialog
      open={dialog?.open}
      onClose={onClose}
      css={css`
        z-index: 4000;
      `}
    >
      <DialogTitle>{dialog?.title}</DialogTitle>
      <DialogContent>{dialog?.content}</DialogContent>
      <DialogActions>
        {(dialog?.actions || []).map((x, i) => (
          <Button
            key={i}
            onClick={() => {
              if (typeof x.onClick === 'function') {
                x.onClick();
              } else {
                onClose(x.value);
              }
            }}
          >
            {x.label}
          </Button>
        ))}
      </DialogActions>
    </MuiDialog>
  );
}
